import tw from 'twin.macro';

export const Wrapper = tw.footer`pt-6 pb-8 text-center bg-gray-100 font-thin`;
